$(document).on('click', '.js-faqToggle', function() {
  const _this = $(this);

  if (_this.hasClass('not_show')) return

  _this.parent().toggleClass('is_active');
  _this.next().slideToggle(200);
});
